const country = [
  {
    country_name: "Canada",
    country_code: "CA",
   
  },
  {
    country_name: "Australia",
    country_code: "AU",
  },
  {
    country_name: "United Kingdom",
    country_code: "GB",
  },
  
];

export default country;
